module.exports = __webpack_public_path__ + "static/media/idris_adeeb.93f6dd35.png";